import { ChangeDetectionStrategy, Component, contentChild, input, model, TemplateRef } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ScrollerModule } from 'primeng/scroller'
import { SkeletonModule } from 'primeng/skeleton'
import { LazyLoadEvent } from 'primeng/api'
import { AbstractContentSidebarStateService } from '../../services/abstract-content-sidebar-state.service'
import { ItemSnappedHeightDirective } from '@directives/item-snapped-height.directive'

@Component({
  selector: 'albert-content-sidebar-list-view',
  standalone: true,
  imports: [CommonModule, ScrollerModule, SkeletonModule, ItemSnappedHeightDirective],
  templateUrl: './content-sidebar-list-view.component.html',
  styleUrl: './content-sidebar-list-view.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.--item-size.px]': 'itemSize()'
  }
})
export class ContentSidebarListViewComponent<T> {
  public readonly service = input.required<AbstractContentSidebarStateService<T>>()
  public readonly itemSize = input<number>(180)
  public readonly pageSize = input<number>(20)
  public readonly sidebarDrawerVisible = model(false)

  public readonly itemTemplate = contentChild<TemplateRef<{ $implicit: T }>>('itemTemplate')

  public onLoadLazy(event: LazyLoadEvent): void {
    const last = event.last ?? 0
    const page = Math.floor(last / this.pageSize())
    this.service().loadMoreItems(page, this.pageSize()).subscribe()
  }

  public onEntryClick(): void {
    this.sidebarDrawerVisible.set(false)
  }
}
